import { c as _c } from "react-compiler-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import { FEATURES } from '../constants/features';
import { TABS } from '../constants/tabs';
import Tab from './sidebar/Tab';
import { MIN_SIDEBAR_WIDTH } from '../constants/sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
// For tab content that needs to be rendered outside of the iFrame
export default function ParentRenderedContent(t0) {
  "use memo";

  const $ = _c(11);
  const {
    tab,
    show,
    enabledFeatures,
    ApprovalsContent
  } = t0;
  let t1;
  if ($[0] !== enabledFeatures) {
    t1 = enabledFeatures && enabledFeatures.length && enabledFeatures.includes(FEATURES.APPROVALS);
    $[0] = enabledFeatures;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isApprovalsEnabled = t1;
  const isApprovalsTabSelected = tab === TABS.APPROVALS;
  const showApprovalsContent = show && ApprovalsContent && isApprovalsEnabled && isApprovalsTabSelected;
  if (!showApprovalsContent) {
    return null;
  }
  let t2;
  if ($[2] !== ApprovalsContent || $[3] !== showApprovalsContent) {
    t2 = showApprovalsContent && ApprovalsContent && /*#__PURE__*/_jsx(ApprovalsContent, {});
    $[2] = ApprovalsContent;
    $[3] = showApprovalsContent;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const approvalsContent = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      minWidth: MIN_SIDEBAR_WIDTH
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== approvalsContent || $[7] !== tab) {
    t4 = approvalsContent ? /*#__PURE__*/_jsx(Tab, {
      heading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `collaborationSidebar.tabs.${tab}`
      }),
      tab: tab,
      children: approvalsContent
    }) : null;
    $[6] = approvalsContent;
    $[7] = tab;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = /*#__PURE__*/_jsx("div", {
      style: t3,
      children: t4
    });
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}